document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('[id*="17864448367c5b8266"]');
  if (!section) return;
  var items = section.querySelectorAll(':scope > * > *, :scope > *');
  var cards = Array.from(items).slice(0, 4);
  cards.forEach(function(el, i) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(160px)';
    el.style.transition = 'opacity 2s ease-out ' + (i * 150) + 'ms, transform 2s ease-out ' + (i * 150) + 'ms';
  });
  var observer = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting) {
      cards.forEach(function(el) {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      });
      observer.disconnect();
    }
  }, { threshold: 0.15 });
  observer.observe(section);
});
